import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["cell", "summary"]

  connect() {
    this.updateSummary()
  }

  updateSummary() {
    let total = 0

    this.cellTargets.forEach(cell => {
      const input = cell.querySelector(".work-man-hours")
      const value = parseFloat(input?.value || 0)
      total += value
    })

    if (this.hasSummaryTarget) {
      this.summaryTarget.textContent = total.toFixed(2)
    }
  }
}